import { loadSlider } from '../shared/utils/swiper';

const loadRecommendedProducts = async () => {
  document
    .querySelectorAll<HTMLElement>('.js-async-recommended-products')
    .forEach(async (element) => {
      try {
        const { url } = element.dataset;
        if (!url)
          throw new Error(
            'URL could not be found for loading recommended products'
          );
        const request = await fetch(url);
        const section = await request.text();

        if (section.includes('js-empty-recommendations-msg')) {
          const sectionToRemove = document.querySelector<HTMLDivElement>(
            '.js-recommendations-title'
          )?.parentElement;

          if (sectionToRemove) {
            sectionToRemove.remove();
          }
        } else {
          // Override section content (loading placeholder)
          element.innerHTML = section;

          // We use the section id from .js-async-recommended-products to scope the slider initialization
          // to avoid initializing the slider multiple times
          loadSlider(
            `#${element.id} .js-recommended-products-slider-async`,
            {}
          );
        }
      } catch (error) {
        // Fail silently
        console.error(error);
        return;
      }
    });
};

loadRecommendedProducts();
